import * as React from 'react'
import type {LoaderFunctionArgs} from 'react-router'

import AppRoutes from '../../../routes'
import type {PreloadedEndpointsLoaderData} from '../../../routes/loadEndpoint'
import store from '../../../store'
import {toBuildId, toPipelineId} from '../../../types'
import {queryToObject} from '../../../utils/queryParams'

import {CreatePipelinePageEntryPoint} from './CreatePipelinePage/CreatePipelinePage.entryPoint'
import {IndexPageEntryPoint} from './IndexPage/IndexPage.entryPoint'
import {PipelinePageEntryPoint} from './PipelinePage/PipelinePage.entryPoint'
import {preloadPipelinePage} from './PipelinePage/PipelinePage.preload'
import {PipelineRunPageEntryPoint} from './PipelineRunPage/PipelineRunPage.entryPoint'
import {preloadPipelineRunPage} from './PipelineRunPage/PipelineRunPage.preload'
import PipelinesPagesErrorBoundary from './PipelinesPages.errorBoundary'
import {WelcomePageEntryPoint} from './WelcomePage/WelcomePage.entryPoint'

const PipelinesPages = React.lazy(
  () =>
    import(
      /* webpackChunkName: "PipelinesPages" */
      './PipelinesPages'
    ),
)

const pipelinesPrefixLength = AppRoutes.PIPELINES.length - 1
const pipelinePrefixLength = AppRoutes.PIPELINE_PAGES.length - 1

export const pipelinesPagesRoutes = [
  {
    path: AppRoutes.PIPELINES,
    Component: PipelinesPages,
    ErrorBoundary: PipelinesPagesErrorBoundary,
    children: [
      {index: true, entryPoint: IndexPageEntryPoint},
      {
        path: AppRoutes.WELCOME_PIPELINES.slice(pipelinesPrefixLength),
        entryPoint: WelcomePageEntryPoint,
      },
      {
        path: AppRoutes.CREATE_PIPELINE.slice(pipelinesPrefixLength),
        entryPoint: CreatePipelinePageEntryPoint,
      },
    ],
  },
  {
    path: AppRoutes.PIPELINE_PAGES,
    Component: PipelinesPages,
    ErrorBoundary: PipelinesPagesErrorBoundary,
    children: [
      {
        path: AppRoutes.PIPELINE_RUN.slice(pipelinePrefixLength),
        entryPoint: PipelineRunPageEntryPoint,
        loader: ({params, request}: LoaderFunctionArgs): PreloadedEndpointsLoaderData => {
          const url = new URL(request.url)
          const queryParams = queryToObject(url.search)
          return {
            preloadedEndpoints: store.dispatch(
              preloadPipelineRunPage(
                toPipelineId(params.pipelineId ?? ''),
                toBuildId(params.pipelineRunId ?? ''),
                queryParams,
              ),
            ),
          }
        },
      },
      {
        path: AppRoutes.PIPELINE.slice(pipelinePrefixLength),
        entryPoint: PipelinePageEntryPoint,
        loader: ({params, request}: LoaderFunctionArgs): PreloadedEndpointsLoaderData => {
          const url = new URL(request.url)
          const queryParams = queryToObject(url.search)
          return {
            preloadedEndpoints: store.dispatch(
              preloadPipelinePage(toPipelineId(params.pipelineId ?? ''), queryParams),
            ),
          }
        },
      },
    ],
  },
]
